import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        compressorTableList: []
    }),
    getters: {
        getCompressorTableList(state) {
            return state.compressorTableList
        },
    },
    mutations: {
        setCompressorTableList(state, options) {
            state.compressorTableList = options
        },
    },
    actions: {
        async getApiCompressorsTable(context) {
            await axios.get('compressor/table/').then(response=>{
                context.commit('setCompressorTableList', response.data)
            }).catch(err=>{
                ElMessage.error('Ошибка выгрузки данных');
            })
        },
    }
}